import { Box } from '@alf/uikit';
import { useI18n } from '@namespace/i18n';
import { useSearchParams } from '@namespace/router';
import { ALL_FILTER_TYPE } from '../../constants';
import { Filters } from './components/Filters';
import { NotificationMessagesList } from './components/NotificationMessagesList';

import styles from './index.module.css';

export const NotificationMessages = () => {
  const { f } = useI18n();
  const params = useSearchParams();

  const currentFilter = {
    startDate: f.getDateTime().minus({ days: 89 }).toISODate(),
    endDate: f.getDateTime().plus({ days: 1 }).toISODate(),
    status: ALL_FILTER_TYPE,
    category: ALL_FILTER_TYPE,
    dateOptionId: '90',
    ...params
  };

  return (
    <Box direction="column" className={styles.container}>
      <Filters
        currentFilter={currentFilter}
        classNames={{
          filterClassName: styles.filterWrapper
        }}
      />
      <NotificationMessagesList currentFilter={currentFilter} />
    </Box>
  );
};
